import {useCallback, useMemo} from 'react'
import {useHistory} from 'utils/routes'

export function useTransactionHowToPay({
  payment_invoice,
  payment_type,
  transaction_method,
  transaction_date,
  transaction_total,
}: {
  payment_type: string
  transaction_method: string
  payment_invoice: string
  transaction_date: string
  transaction_total: number
}) {
  const history = useHistory()

  const enableHowToPayButton = useMemo(
    () =>
      payment_type === 'Virtual Account' ||
      payment_type === 'Retail' ||
      transaction_method === 'QRIS' ||
      (payment_type === 'Ewallet' &&
        (transaction_method === 'GoPay' || transaction_method === 'ShopeePay')),
    [payment_type, transaction_method],
  )

  const handleHowToPay = useCallback(() => {
    transaction_method === 'GoPay' || transaction_method === 'ShopeePay'
      ? history.push('giftshop_ewallet_payment_history', {
          invoiceId: payment_invoice,
          paymentMethod: transaction_method,
          transactionDate: new Date(transaction_date),
        })
      : transaction_method === 'QRIS'
      ? history.push('giftshop_payment_qris_history', {
          transaction_time: transaction_date,
          total_payment: transaction_total,
          invoice_id: payment_invoice,
        })
      : history.push('giftshop_payment_history', {
          invoiceId: payment_invoice,
          paymentMethod: transaction_method,
          paymentType: payment_type,
          transactionDate: new Date(transaction_date),
        })
  }, [
    transaction_method,
    history,
    payment_invoice,
    transaction_date,
    transaction_total,
    payment_type,
  ])

  return useMemo(
    () => ({
      enableHowToPayButton,
      handleHowToPay,
    }),
    [enableHowToPayButton, handleHowToPay],
  )
}
